<style>
    svg {
        width: 80px;
    }

    .st0 {
        fill:#727272;
    }
</style>

<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 68.5 86.2" style="enable-background:new 0 0 68.5 86.2;" xml:space="preserve">
    <path class="st0" d="M0,64.8h3l7.3,17.8h0.1l7.3-17.8h3v21.1h-2.4V69.6h-1.2l2.8-4.2l-8.5,20.6H9.3L0.8,65.3l2.8,4.2H2.5v16.3H0
        V64.8z"/>
    <path class="st0" d="M29.4,85.2c-1.1-0.7-1.9-1.6-2.5-2.8c-0.6-1.3-0.9-2.7-0.9-4.2l0,0c0-1.4,0.3-2.9,0.9-4.2
        c0.5-1.1,1.4-2.1,2.5-2.7c2.3-1.3,5.1-1.3,7.4,0c1.1,0.7,1.9,1.6,2.5,2.7c0.6,1.3,0.9,2.7,0.9,4.2l0,0c0,1.5-0.3,2.9-0.9,4.2
        c-0.5,1.1-1.4,2.1-2.5,2.7C34.5,86.5,31.7,86.5,29.4,85.2z M35.4,83.2c0.7-0.5,1.2-1.2,1.5-1.9c0.4-1,0.6-2,0.6-3.1l0,0
        c0-1-0.2-2-0.6-3c-0.3-0.8-0.9-1.4-1.6-1.9c-0.7-0.4-1.5-0.7-2.3-0.7c-0.8,0-1.6,0.2-2.3,0.7c-0.7,0.5-1.2,1.1-1.6,1.9
        c-0.4,1-0.6,2-0.6,3l0,0c0,1,0.2,2.1,0.6,3.1c0.3,0.8,0.9,1.5,1.6,1.9c0.7,0.5,1.5,0.7,2.3,0.7C33.9,83.9,34.7,83.7,35.4,83.2
        L35.4,83.2z"/>
    <path class="st0" d="M45,70.7h2.6v2.6h0.1c0.2-0.8,0.7-1.5,1.3-2.1c0.6-0.5,1.4-0.8,2.2-0.8c0.2,0,0.4,0,0.6,0l0.4,0.1v2.5
        c-0.2-0.1-0.3-0.1-0.5-0.1c-0.3,0-0.6,0-0.9,0c-0.6,0-1.2,0.1-1.7,0.4c-0.5,0.3-0.9,0.7-1.1,1.3c-0.3,0.6-0.4,1.3-0.4,2v9.4H45
        L45,70.7z"/>
    <path class="st0" d="M58.2,85.2c-1.1-0.7-1.9-1.6-2.4-2.7c-0.6-1.3-0.9-2.7-0.8-4.2l0,0c0-1.4,0.3-2.9,0.9-4.2
        c0.5-1.1,1.3-2.1,2.4-2.8c2.2-1.3,5-1.3,7.2-0.1c1,0.7,1.8,1.6,2.3,2.7c0.6,1.3,0.8,2.6,0.8,4v1H56.2v-2h11L66,78.8v-1
        c0-1-0.1-2-0.5-2.9c-0.3-0.7-0.8-1.3-1.5-1.7c-0.7-0.4-1.4-0.6-2.2-0.6c-0.8,0-1.5,0.2-2.2,0.6c-0.7,0.4-1.2,1.1-1.5,1.8
        c-0.4,0.9-0.6,1.9-0.6,2.9v1c0,0.9,0.2,1.9,0.6,2.8c0.3,0.7,0.9,1.3,1.6,1.8c0.7,0.4,1.6,0.6,2.4,0.6c0.6,0,1.2-0.1,1.7-0.3
        c0.5-0.2,0.9-0.4,1.3-0.8c0.3-0.3,0.6-0.7,0.7-1.2v-0.1h2.6v0.2c-0.1,0.6-0.4,1.2-0.7,1.8c-0.4,0.6-0.8,1-1.4,1.4
        c-0.6,0.4-1.2,0.8-1.9,1c-0.7,0.2-1.5,0.3-2.3,0.3C60.7,86.3,59.4,85.9,58.2,85.2z"/>
    <g id="more">
        <circle class="st0" cx="9.7" cy="30.2" r="8.2"/>
        <circle class="st0" cx="33.7" cy="30.2" r="8.2"/>
        <circle class="st0" cx="57.7" cy="30.2" r="8.2"/>
    </g>
</svg>